/** An end at or before the start means the slot runs past midnight onto the
 *  next day — the same reading the selling-time validation is written on. */
export function slotEnd(day: string, startTime: string, endTime: string): Date {
  const end = new Date(`${day}T${endTime}:00`);
  if (endTime <= startTime) end.setDate(end.getDate() + 1);
  return end;
}
